<template>
  <div class="app-login is-flex is-align-items-centered" style="margin-left: auto">
    <!-- OTP LOGIN -->
    <div class="otp-login">
      <div v-if="!state.showOTPInput" class="otp-user is-flex is-align-items-center">
        <div class="input-container" style="position: relative">
          <input
            class="input is-small my-1"
            style="width: 200px"
            type="text"
            v-model="state.username"
            placeholder="gebruiker"
            title="Voer je gebruikersnaam in. We sturen je een OTP code."
          />
        </div>

        <button
          class="button is-small mx-0"
          :class="state.isLoading && 'is-loading'"
          @click="requestOTP"
          :disabled="!state.username.trim()"
        >
          Verstuur
        </button>
      </div>
      <div v-else class="otp-code is-flex is-align-items-center">
        <i
          class="fas fa-user has-text-white mx-1 is-clickable"
          title="Verander gebruiker"
          @click="changeUser"
        ></i>
        <i
          class="fas fa-redo-alt has-text-white mx-1 mr-2 is-clickable"
          title="Vraag nieuwe OTP code aan"
          @click="requestOTP"
        ></i>
        <input
          class="input is-small my-1"
          style="width: 120px; font-family: monospace; letter-spacing: 1px"
          type="text"
          v-model="state.otp"
          placeholder="OTP code"
          maxlength="6"
          title="Voer de 6-cijferige OTP code in die je hebt ontvangen"
        />
        <button
          class="button is-small mx-0"
          :class="state.isLoading && 'is-loading'"
          @click="sendOTP"
          :disabled="!state.otp.trim()"
        >
          Login
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { actions } from '@/store'

const REMEMBER_USERNAME_KEY = 'login-remember-username'

const props = defineProps({
  auth: {
    type: Object,
    required: true,
  },
})

const state = reactive({
  showOTPInput: false,
  username: '',
  otp: '',
  isLoading: false,
})

// Load remembered username on mount
onMounted(() => {
  const remembered = localStorage.getItem(REMEMBER_USERNAME_KEY)
  if (remembered) {
    state.username = remembered
  }
})

function handleRememberUsername() {
  if (state.username.trim()) {
    localStorage.setItem(REMEMBER_USERNAME_KEY, state.username.trim())
  }
}

async function requestOTP() {
  if (!state.username.trim()) return

  state.isLoading = true

  try {
    const response = await props.auth.requestOTP(state.username.toLowerCase().trim())

    if (response.status === 'OK') {
      handleRememberUsername()
      state.showOTPInput = true
      actions.common.commitNotifications([
        {
          message: 'OTP code verstuurd',
          type: 'success',
        },
      ])
    } else {
      actions.common.commitNotifications([
        {
          message: 'Er is iets misgegaan, probeer het opnieuw',
          type: 'danger',
        },
      ])
    }
  } catch (error) {
    actions.common.commitNotifications([
      {
        message: 'Er is iets misgegaan, probeer het opnieuw',
        type: 'danger',
      },
    ])
  } finally {
    state.isLoading = false
  }
}

async function sendOTP() {
  if (!state.otp.trim()) return

  state.isLoading = true

  try {
    const response = await props.auth.loginWithOTP(
      state.username.toLowerCase().trim(),
      state.otp.trim()
    )

    if (response.status === 'OK') {
      state.showOTPInput = false
      actions.common.commitNotifications([])
    } else {
      actions.common.commitNotifications([
        {
          message: 'OTP code is verkeerd of verlopen',
          type: 'danger',
        },
      ])
    }
    state.otp = ''
  } catch (error) {
    actions.common.commitNotifications([
      {
        message: 'OTP code is verkeerd of verlopen',
        type: 'danger',
      },
    ])
    state.otp = ''
  } finally {
    state.isLoading = false
  }
}

function changeUser() {
  state.showOTPInput = false
  state.otp = ''
  actions.common.commitNotifications([])
}
</script>
